import { isDevPanelEnabled } from "@components/DevPanel/devSettings/isDevPanelEnabled";

import { MockSpec, parseMockSpec } from "./mockSpec";

/**
 * Persistence for the AI-generated mock override. The spec lives in localStorage and is read on
 * bootstrap by `createMockExecutor`. Reads are gated by `isDevPanelEnabled()` — the same
 * production-safety guard the "Mock data" toggle uses — so a stray key can never change behaviour in
 * production. Every access is try/catch-wrapped (Safari private mode etc.), matching `storage.ts`.
 */

export const MOCK_OVERRIDE_STORAGE_KEY = "dev:mockOverrideSpec";

export const getMockOverrideSpec = (): MockSpec | undefined => {
  if (!isDevPanelEnabled()) {
    return undefined;
  }

  try {
    const raw = window.localStorage.getItem(MOCK_OVERRIDE_STORAGE_KEY);
    if (!raw) {
      return undefined;
    }
    const result = parseMockSpec(raw);
    return result.ok ? result.data : undefined;
  } catch {
    return undefined;
  }
};

export const setMockOverrideSpec = (spec: MockSpec): void => {
  try {
    window.localStorage.setItem(MOCK_OVERRIDE_STORAGE_KEY, JSON.stringify(spec));
  } catch {
    // localStorage unavailable — silently ignore.
  }
};

export const clearMockOverrideSpec = (): void => {
  try {
    window.localStorage.removeItem(MOCK_OVERRIDE_STORAGE_KEY);
  } catch {
    // localStorage unavailable — silently ignore.
  }
};

export const hasMockOverrideSpec = (): boolean => getMockOverrideSpec() !== undefined;
